<template>
  <div class="sign" style="overflow-x: auto">
    <div v-if="noSign && sqputongJiandu.enable">
      <a-form  slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="sqputongJiandu.phone" placeholder="请输入联系方式"  ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="sqputongJiandu.yijian">
            <a-form-item label="监理意见" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea  name="saysth" rows="3" cols="20" placeholder="请填写工程监理意见" class="inputclass" v-model="sqputongJiandu.msg" style="width: 100%;margin-top:10px;"></a-textarea>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" style="text-align: center">
            <div>
              <a-button type="primary"  size="large" @click="nextStep">开始签名</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div v-if="noSign && baogaoYsjldan.enable">
      <a-form  slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="存在问题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea  name="saysth" rows="3" cols="20" placeholder="请填写存在问题" class="inputclass" v-model="baogaoYsjldan.msg" style="width: 100%;margin-top:10px;"></a-textarea>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" style="text-align: center">
            <div>
              <a-button type="primary"  size="large" @click="nextStep">开始签名</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div v-if="noSign && baogaoYsjldan_expertSign.enable">
      <a-form  slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="单位名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="baogaoYsjldan_expertSign.msg" placeholder="请输入单位名称"  ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label="本人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="baogaoYsjldan_expertSign.name" placeholder="请输入本人姓名"  ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" style="text-align: center">
            <div>
              <a-button type="primary"  size="large" @click="nextStep">开始签名</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
     <p  v-if="noSign && showSign" class="sign-title">建议您调整手机，横向进行签名,可左右滑动调整签名区大小</p>
    <div v-if="noSign && showSign" class="btnList" ref="btnList">
      <div>
<!--        <a-button type="primary"  size="large" @click="preStep">上一步</a-button>-->
        &nbsp;
        <a-button type="danger"  size="large" @click="clearSignImg">清空</a-button>
        &nbsp;
        <a-button type="primary"  size="large" @click="saveSignImg">签字提交</a-button>
      </div>
    </div>
    <div v-if="!noSign" class="signComplete">
      签名完成,请手动关闭此页
    </div>
    <sign-canvas
      v-if="noSign && showSign"
      class="sign-canvas"
      ref="SignCanvas"
      :options="options"
      v-model="value"
    />
  </div>
</template>

<script>
  import {postAction} from "@/api/manage";
  import preventBack from 'vue-prevent-browser-back';
  import signCanvas from "sign-canvas";
  import ACol from "ant-design-vue/es/grid/Col";
  export default {
    name: 'sign',
    mixins: [preventBack],//注入  阻止返回上一页
    components: {ACol, signCanvas},
    data() {
      return {
        sqputongJiandu:{
          enable:false,
          yijian:false,
          phone:"",
          msg:""
        },
        baogaoYsjldan:{
          enable:false,
          phone:"",
          msg:""
        },
        baogaoYsjldan_expertSign:{
          enable:false,
          phone:"",
          msg:"",
          name:""
        },
        imgBase64:"",
        value: null,
        wsobj:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        //配置画布
        options: {
          lastWriteSpeed: 1, //书写速度 [Number] 可选
          lastWriteWidth: 2, //下笔的宽度 [Number] 可选
          lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
          lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
          canvasWidth: "230", //canvas宽高 [Number] 可选
          canvasHeight: "650", //高度  [Number] 可选
          isShowBorder: false, //是否显示边框 [可选]
          bgColor: "#fff", //背景色 [String] 可选
          borderWidth: 1, // 网格线宽度  [Number] 可选
          borderColor: "#ff787f", //网格颜色  [String] 可选
          writeWidth: 3, //基础轨迹宽度  [Number] 可选
          maxWriteWidth: 50, // 写字模式最大线宽  [Number] 可选
          minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
          writeColor: "#101010", // 轨迹颜色  [String] 可选
          isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
          imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
        },
        isbase64:"",
        noSign:true,
        showSign:true
      };
    },
    mounted() {  },
    created(){
      if(this.$route.params.field=="sqputong_jiandu"){
        this.sqputongJiandu.enable=true;
        this.sqputongJiandu.yijian=true;
        this.showSign=false;
      }
      if(this.$route.params.field=="sqbeian_chuyanFuZheRen" || this.$route.params.field=="sqputong_chuyanFuZheRen"){
        this.sqputongJiandu.enable=true;
        //this.sqputongJiandu.yijian=false;
        this.showSign=false;
      }
      else if(this.$route.params.field=="baogao_yanshoudan"){
        this.baogaoYsjldan.enable=true;
        this.showSign=false;
      }
      else if(this.$route.params.field=="baogao_expertSign"){
        this.baogaoYsjldan_expertSign.enable=true;
        this.showSign=false;
      }

    },
    methods:{
      preStep(){
        this.showSign=false;
      },
      nextStep(){
        this.showSign=true;
      },
    //清除画板
    clearSignImg(){
      this.$refs.SignCanvas.canvasClear();
    },
    // 保存图片
    saveSignImg(){
      //监理数据
      let jianliFlag=true;
      if(this.sqputongJiandu.enable){
          if(this.sqputongJiandu.phone==""){
            jianliFlag=false;
            this.$message.error('请输入联系方式');
          }
        if(this.sqputongJiandu.msg=="" && this.sqputongJiandu.yijian){
          jianliFlag=false;
          this.$message.error('请填写工程监理意见');
        }
      }
      else if(this.baogaoYsjldan_expertSign.enable){
        if(this.baogaoYsjldan_expertSign.msg==""){
          jianliFlag=false;
          this.$message.error('请填写单位名称');
        }
        if(this.baogaoYsjldan_expertSign.name==""){
          jianliFlag=false;
          this.$message.error('请填写本人姓名');
        }
      }

      if (this.value == null) {
        this.$message.error('请先签名');
      } else {
        if(jianliFlag){
          this.rotateBase64Img(this.value, 270,this.callback);
        }
      }

      this.setDialogH()

    },
    //签名写出来的的角度不对 将base64转换度数
    rotateBase64Img(src, edg, callback){
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var imgW;//图片宽度
      var imgH;//图片高度
      var size;//canvas初始大小
      if (edg % 90 != 0) {
        console.error("旋转角度必须是90的倍数!");
        throw '旋转角度必须是90的倍数!';
      }
      (edg < 0) && (edg = (edg % 360) + 360)
      const quadrant = (edg / 90) % 4; //旋转象限
      const cutCoor = {sx: 0, sy: 0, ex: 0, ey: 0}; //裁剪坐标
      var image = new Image();
      image.crossOrigin = "anonymous"
      image.src = src;
      image.onload = function () {
        imgW = image.width;
        imgH = image.height;
        size = imgW > imgH ? imgW : imgH;
        canvas.width = size * 2;
        canvas.height = size * 2;
        switch (quadrant) {
          case 0:
            cutCoor.sx = size;
            cutCoor.sy = size;
            cutCoor.ex = size + imgW;
            cutCoor.ey = size + imgH;
            break;
          case 1:
            cutCoor.sx = size - imgH;
            cutCoor.sy = size;
            cutCoor.ex = size;
            cutCoor.ey = size + imgW;
            break;
          case 2:
            cutCoor.sx = size - imgW;
            cutCoor.sy = size - imgH;
            cutCoor.ex = size;
            cutCoor.ey = size;
            break;
          case 3:
            cutCoor.sx = size;
            cutCoor.sy = size - imgW;
            cutCoor.ex = size + imgH;
            cutCoor.ey = size + imgW;
            break;
        }
        ctx.translate(size, size);
        ctx.rotate(edg * Math.PI / 180);
        ctx.drawImage(image, 0, 0);
        var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
        if (quadrant % 2 == 0) {
          canvas.width = imgW;
          canvas.height = imgH;
        } else {
          canvas.width = imgH;
          canvas.height = imgW;
        }
        ctx.putImageData(imgData, 0, 0);
        callback(canvas.toDataURL())
      };
    },
    callback(base64data){
      //let a = this.base64toFile(base64data) //将base64转换成file流文件进行上传
      let that=this;
      this.$confirm({
        title: "签名确认",
        class: 'btnList',
        okText: '确定',
        cancelText: '取消',
        content: "请先确认签名是否正确,一旦签名成功,无法撤销",
        onOk: function () {
          that.upImg(base64data)
        },
      });

      this.setDialogH();
    },
      //设置弹出框横向
      setDialogH(){
        setTimeout(function() {
          var d=document.getElementsByClassName("ant-message")
          if(d[0]!=undefined){
            d[0].style.cssText="transform: rotate(90deg)";
          }
          var alterModal=document.getElementsByClassName("ant-modal-content")
          if(alterModal[0]!=undefined){
            alterModal[0].style.cssText="transform: rotate(90deg)";
          }

        },100)
      },
    base64toFile(dataurl, filename = 'file'){
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    GetQueryString(name)
    {
      var a = decodeURI(window.location.search)
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = a.substr(1).match(reg);
      if(r!=null)return unescape(r[2]); return null;
    },
    //上传照片
    upImg(signBase64file){
      //正常调用接口上传就可以了
      // let field=this.GetQueryString("field");
      // let projectId=this.GetQueryString("projectId");
      let field=this.$route.params.field;
      let packageId=this.$route.params.projectId;
      let planId=this.$route.params.planId;
      let upfile=this.$route.params.upfile;
      let orgcode=this.$route.params.sysOrgCode;
      if(upfile==null || upfile==undefined){
        upfile=""
      }
      //console.log('field:'+field+" projectId:"+projectId);
      let url="/uaps_ele_signature/uapsEleSignature/addmobile";
      let params={packageId:packageId,filedName:field,elSign:signBase64file,accId:planId,ysxiaozuFile:upfile,sysOrgCode:orgcode};
      //申请 工程监理意见
      if(this.sqputongJiandu.enable){
        params.phone=this.sqputongJiandu.phone;
        params.msg=this.sqputongJiandu.msg;
      }
      //报告 验收记录单
      if(this.baogaoYsjldan.enable){
        params.msg=this.baogaoYsjldan.msg;
      }
      //报告 专家签到
      if(this.baogaoYsjldan_expertSign.enable){
        params.msg=this.baogaoYsjldan_expertSign.msg;
        params.expertName=this.baogaoYsjldan_expertSign.name;
      }
      postAction(url, params).then(res=>{
        res=res.data;
        if(res.success){
          // this.$message.success('签字成功');
          this.noSign=false;
        }else{
          this.$message.error(res.message);
          this.setDialogH();
        }
      })
    },

  }
  }
</script>


<style scoped>
  .ant-modal-content1{
    transform: rotate(90deg);
  }
  .btnList {
      position: fixed;
      /*top: 20%;*/
      left: -40%;
      width: 100%;
      padding: 100px 0;
      display: flex;
      justify-content: center;
      transform: rotate(90deg);
    }
  .signComplete {
    position: fixed;
    font-size:2em;
    color:green;
    width: 100%;
    padding: 45% 0;
    display: flex;
    justify-content: center;
    transform: rotate(90deg);
  }
  .sign {
    padding: 10px;
    overflow-x: scroll;
  }
  .sign-title{
    font-weight: bold;
    padding: 10px 0;
  }
  .sign-canvas {
    background: #F1F1F1 !important;
    border-radius: 8px;
    position: absolute;
    right: 20px;
    border: 1px solid #000;
  }
  .signName{
    border: 1px solid #000;
  }
</style>
